import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const normalizeSSN = value => {
  // If the user modifies digits within sections, it will pass the validation,
  // because we don't want to re-render all the time, which cause cursor jumping.
  if (!value) return ''
  if (value.includes('*')) return value
  if (/^\d{1,3}-\d{1,2}-\d{1,4}$/.test(value)) return value

  // Formatting
  const clean = (value.match(/\d/g) || []).join('')
  const arr = clean.split('')
  arr.length > 3 && arr.splice(3, 0, '-')
  arr.length > 6 && arr.splice(6, 0, '-')
  arr.length > 11 && arr.splice(11, 1)
  return arr.join('')
}

const enhance = compose(
  withProps({
    // using normalize instead o format because the form validation
    // is checking against what's in redux, but format only affects
    // what the user sees in the field, not what is getting saved.
    normalize: normalizeSSN,
  }),
  toReduxFormField('InputSSN'),
)

export default enhance(InputText)
